<script>
import NextMixinListPage from "@/components/mixins/NextMixinListPage";
import MixinActions from "@/components/mixins/MixinListActions";
import AppMenu from "../menu/AppMenu.vue";
import MixinListCreditNote from "./MixinListCreditNote";

import * as templateDesktop from "./DeCreditNoteListAnnulledDesktop.vue?vue&type=template";
import * as templateMobile from "./DeCreditNoteListAnnulledMobile.vue?vue&type=template";
import ModalShow from "./ModalShow.vue";
let render = templateDesktop.render;
if (window.innerWidth < 960) {
  render = templateMobile.render;
}

export default {
  mixins: [NextMixinListPage, MixinActions,MixinListCreditNote ],
  components: { ModalShow,AppMenu },
  render: render,
  data() {
    return {
      title: "Notas Crédito DE",
      form: {},
      url: "api/v1/de-credit-note-annulled",
      pathBase: "/pos/de-credit-note",
      pathCreate: "/pos/de-credit-note/create",
      options: {
        page: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
        sortBy: ['created_at'],
        sortDesc: [false]
      },
      tutorial: {"default":"https:\/\/www.youtube.com\/watch?v=0lPTzQWtYow","electronic":"https:\/\/www.youtube.com\/watch?v=0lPTzQWtYow"},
      headers: [
        { title: "num", value: "index", sortable: false },
        { title: "credit_note_date", value: "credit_note_date", sortable: true, class: "th-credit_note_date", cellClass: "td-credit_note_date" },
        { title: "consecutive_credit_note", value: "consecutive_credit_note", sortable: true, class: "th-consecutive_credit_note", cellClass: "td-consecutive_credit_note" },
        { title: "invoice", value: "invoice", sortable: false, class: "th-invoice", cellClass: "td-invoice" },
        { title: "is_validate", value: "is_validate", sortable: true, class: "th-is_validate", cellClass: "td-is_validate" },
        { title: "status_dian", value: "status_dian", sortable: true, class: "th-status_dian", cellClass: "td-status_dian" },
        { title: "total_note", value: "total_note", sortable: true, class: "th-total_note", cellClass: "td-total_note" },
        { title: "_actions", value: "_actions", sortable: false }
      ],
          };
  },
  methods: {
    breadcrumbsInit() {
        this.breadcrumbs = [
            { text: this.$t('Inicio'), disabled: false, to: '/admin', 'exact-path': true },
            { text: this.$t('Ventas e Ingresos'), disabled: true, to: '', 'exact-path': true },
            { text: this.$t('Notas Crédito DE'), disabled: true, to: '', 'exact-path': true },
            { text: this.$t('de-credit-note-list-annulled'), disabled: true, to: '', 'exact-path': true },
        ];
    },
  },
};
</script>
